import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteDefinition } from './types';

const Books = lazy(() => import('../pages/Books'));
const NarrowReading = lazy(() => import('../pages/NarrowReading'));
const LessonDetail = lazy(() => import('../pages/LessonDetail'));
const PreTestSession = lazy(() => import('../pages/PreTestSession'));
const Progress = lazy(() => import('../pages/Progress'));
const Settings = lazy(() => import('../pages/Settings'));
const SmartReview = lazy(() => import('../pages/SmartReview'));
const OnboardingPage = lazy(() => import('../pages/OnboardingPage'));

export const coreRoutes: RouteDefinition[] = [
  // Learn (Books) — default tab
  { path: '/', element: <Books />, guard: 'onboarding', layout: 'tabs' },
  { path: '/books', element: <Navigate to="/" replace /> },
  { path: '/lesson/:lessonId', element: <LessonDetail />, guard: 'lesson', layout: 'tabs' },
  { path: '/pretest/:lessonId', element: <PreTestSession />, guard: 'lesson' },
  // Read (Narrow Reading)
  { path: '/read', element: <NarrowReading />, guard: 'onboarding', layout: 'tabs' },
  // Review (SRS)
  { path: '/review', element: <SmartReview />, guard: 'onboarding', layout: 'tabs' },
  // Progress & Profile
  { path: '/progress', element: <Progress />, guard: 'onboarding', layout: 'tabs' },
  // Settings
  { path: '/settings', element: <Settings />, guard: 'onboarding', layout: 'tabs' },
  // Onboarding (uses its own guard)
  { path: '/onboarding', element: <OnboardingPage />, guard: 'onboarding-guard' },
];
